import { Component, OnInit } from '@angular/core';

import { MatDialogRef } from '@angular/material/dialog';

import { Lead } from '@app/models';

@Component({
    selector: 'dup-lead-dialog',
    templateUrl: './dup-lead-dialog.component.html',
    styleUrls: ['./dup-lead-dialog.component.scss'],
    standalone: false
})
export class DupLeadDialogComponent implements OnInit {
  items: Lead[] = [];

  constructor(public dialogRef: MatDialogRef<DupLeadDialogComponent>) {}

  ngOnInit() {}

  getFullName(lead: any): string {
    return [lead.first_name, lead.last_name].filter(Boolean).join(' ');
  }

  getLocation(lead: any): string {
    const parts = [lead.current_address?.city, lead.current_address?.state].filter(Boolean);
    return parts.join(', ');
  }

  getPhone(lead: any): string {
    return lead.mobile_phone || lead.home_phone || '';
  }

  getInitials(lead: any): string {
    const first = lead.first_name?.[0] || '';
    const last = lead.last_name?.[0] || '';
    return (first + last).toUpperCase();
  }

  confirmCreate(doMerge: boolean) {
    this.dialogRef.close(doMerge);
  }

  cancel() {
    this.dialogRef.close(null);
  }
}